const EXPIRATION_TIME_MINUTES = 60 * 24
const EXPIRATION_TIME_SECONDS = EXPIRATION_TIME_MINUTES * 60
const EXPIRATION_TIME_MS = EXPIRATION_TIME_SECONDS * 1000

export const salesReps = [
  { id: 12, first_name: 'Colton', last_name: 'Gray' },
  { id: 13, first_name: 'Mike', last_name: 'Liccardi' },
  { id: 71, first_name: 'Scott', last_name: 'Hibbs' },
  { id: 'sara_rivera', first_name: 'Sara', last_name: 'Rivera' },
  { id: 205, first_name: 'Reebs', last_name: 'Nicole' },
  { id: 118, first_name: 'Anthony', last_name: 'Carracino' },
  { id: 254, first_name: 'Michael', last_name: 'Dermek' },
  { id: 240, first_name: 'Michael', last_name: 'Foley' },
  { id: '8xNXNMC48uUvOBzQQqJwoLyu6Gh2', first_name: 'Admin', last_name: 'Admin' },
  { id: '0Zqvi4AL62Nl107tFPV7M2IGQWF2', first_name: 'Nick', last_name: 'Vasto' },
  { id: 'sszt9l9uP4huOtty5pZJO5gNXc83', first_name: 'Jack', last_name: 'Test' },
  { id: '4eO4EJfnvrSKfR7DUI05qV1sqGG3', first_name: 'Emily', last_name: 'Blair' },
]

export { EXPIRATION_TIME_MINUTES, EXPIRATION_TIME_SECONDS, EXPIRATION_TIME_MS }
export * from './permissions'

export * from './apiBaseUrl'